import { spaceMixin } from '@zillow/constellation';
import styled from 'styled-components';

export const ZillowNavbarSectionMegaMenuContentContainer = styled.div`
    max-width: 1280px;
    width: 100%;
    padding: 0 ${spaceMixin('md')};
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
`;
